import { Injectable } from '@angular/core';
import { AppContext } from '../../shared/app-context';

@Injectable({
  providedIn: 'root',
})
export class ApigatewayService {
   constructor(public appContext: AppContext) {}
  public getApiGatewayUrl() {
    const retPromise: Promise<any> = Promise.resolve();
    retPromise.then(() => {
      this.appContext.apiGatewayUrl = localStorage.getItem('baseUrl');
    });
    return retPromise;
  }
}
